export default "__VITE_ASSET__5e393475__"